import { buttonVariants } from '@cocoonspace/ui/components/button'
import { Card } from '@cocoonspace/ui/components/card'
import { Trans, useLingui } from '@lingui/react/macro'
import { TwicImg } from '@twicpics/components/react'
import { ArrowRightIcon } from 'lucide-react'
import Link from 'next/link'

import { SectionTitle } from '~/domains/home/components/section-title'
import { SectionWrapper } from '~/domains/home/components/section-wrapper'

export const HowCocoonDesk = () => {
	const { t } = useLingui()

	return (
		<div className='relative overflow-hidden bg-white'>
			<SectionWrapper>
				<SectionTitle>
					<Trans>
						Pour vos réunions et rendez-vous, <br />
						choisissez Cocoon !
					</Trans>
				</SectionTitle>

				<div className='flex flex-col items-center gap-6 md:flex-row'>
					<div>
						<Card className='relative aspect-video overflow-hidden rounded bg-cover md:w-[550px]'>
							<TwicImg
								focus='50px100p'
								ratio='3/2'
								src='/spaces/cjj2sba23akg00lc6h20'
							/>
						</Card>
					</div>

					<div className='flex flex-1 flex-col gap-6 md:p-6'>
						<div className='flex flex-col gap-3'>
							<div className='flex flex-col text-sm'>
								<strong className='text-primary flex flex-row items-center text-4xl'>
									{t`Simple`}
								</strong>

								<div className='font-bold'>
									{t`Réservation 100 % instantanée, en ligne, en 3 minutes.`}
								</div>

								<div className='text-sm'>
									{t`À l’heure ou à la journée, choisissez votre Cocoon, réservez, entrez...`}
								</div>
							</div>

							<div className='flex flex-col text-sm'>
								<strong className='text-primary flex flex-row items-center text-4xl'>
									{t`Chez soi`}
								</strong>

								<div className='font-bold'>
									{t`Un cadre chaleureux qui brise les codes du bureau traditionnel.`}
								</div>

								<div className='text-sm'>
									{t`Installez-vous confortablement « comme à la maison » pour libérer la réflexion et la cohésion.`}
								</div>
							</div>

							<div className='flex flex-col text-sm'>
								<strong className='text-primary flex flex-row items-center text-4xl'>
									{t`Flexible`}
								</strong>

								<div className='font-bold'>
									{t`Annulation jusqu’à 2h avant, sans frais.`}
								</div>

								<div className='text-sm'>
									{t`Vous êtes libre : payez uniquement quand vous en avez besoin.`}
								</div>
							</div>
						</div>
					</div>
				</div>

				<Link
					className={buttonVariants({
						size: 'sm',
						variant: 'textPrimary',
						className: 'ml-auto',
					})}
					href='https://booking-on-demand.cocoon-space.com'
					rel='noreferrer'
					target='_blank'
					data-umami-event='booking-on-demand-landing-home-click'
				>
					{t`En savoir plus`} <ArrowRightIcon className='ml-1' />
				</Link>
			</SectionWrapper>
		</div>
	)
}
